import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import layoutHeaderAside from '@/layout/header-aside'; // 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载

var _import = require('@/libs/util.import.' + process.env.NODE_ENV);

var meta = {
  auth: true
};
export default {
  path: '/demo/plugins',
  name: 'demo-plugins',
  meta: meta,
  redirect: {
    name: 'demo-plugins-index'
  },
  component: layoutHeaderAside,
  children: [{
    path: 'clipboard-polyfill',
    name: 'demo-plugins-clipboard-polyfill',
    component: _import('demo/plugins/clipboard-polyfill'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '剪贴板访问'
    })
  }, {
    path: 'day',
    name: 'demo-plugins-day',
    component: _import('demo/plugins/day'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '日期计算'
    })
  }, {
    path: 'export/table',
    name: 'demo-plugins-export-table',
    component: _import('demo/plugins/export/table.vue'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '导出表格'
    })
  }, {
    path: 'export/txt',
    name: 'demo-plugins-export-txt',
    component: _import('demo/plugins/export/txt.vue'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '导出文本'
    })
  }, {
    path: 'import/csv',
    name: 'demo-plugins-import-csv',
    component: _import('demo/plugins/import/csv.vue'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '导入 csv'
    })
  }, {
    path: 'import/xlsx',
    name: 'demo-plugins-import-xlsx',
    component: _import('demo/plugins/import/xlsx.vue'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '导入 xlsx'
    })
  }, {
    path: 'index',
    name: 'demo-plugins-index',
    component: _import('demo/plugins/index'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '插件首页'
    })
  }, {
    path: 'js-cookie',
    name: 'demo-plugins-js-cookie',
    component: _import('demo/plugins/js-cookie'),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: 'Cookie'
    })
  }]
};